export enum CustomMessageType {
  Information = 'information',
  Success = 'success',
  Warning = 'warning',
  Error = 'error',
}
